import PlanEntryActiveListRequest from "../../../api/raily/plan-entry/active-list/plan-entry-active-list.request";
import PlanEntryActiveListParams from "./plan-entry-active-list-params";

const create = (
  params: PlanEntryActiveListParams,
): PlanEntryActiveListRequest => {
  return {
    taxiCorporationId: params.taxiCorporationUuid,
    cargoOrderId: params.cargoOrderUuid,
    cargoOrderHumanId: params.cargoOrderHumanId,
  };
};

const planEntryActiveListParamsFactory = {
  create,
};

export default planEntryActiveListParamsFactory;
